import React, { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import ExternalLink from './ExternalLink';

type Props = {
  external?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

const GLink = ({ href, children, external = false, ...others }: Props) => {
  return external ? (
    <ExternalLink href={href} {...others}>
      {children}
    </ExternalLink>
  ) : href && href !== '#' ? (
    <Link to={href} {...others}>
      {children}
    </Link>
  ) : (
    <a href={href} {...others}>
      {children}
    </a>
  );
};

export default GLink;
